import { Component, OnInit, TemplateRef, ViewChild, OnDestroy } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, NgForm } from '@angular/forms';
import { DialogCloseResult, DialogRef, DialogService } from '@progress/kendo-angular-dialog';
import { IAwardDetails, IAwardInfoHeader, ICOISave } from 'src/app/interface/IAwardInfoHeader';
import { IKeyPairValue } from 'src/app/interface/IKeyValuePair';
import { IAwardCountry, IDonorContact, IActivity, ITechnicalArea } from 'src/app/interface/IDonorContact';
import { Common } from 'src/app/common/common';
import { ActivatedRoute, Router } from '@angular/router';
import { CompositeFilterDescriptor, process, State, filterBy, FilterDescriptor } from '@progress/kendo-data-query';
import { DataStateChangeEvent, FilterService, GridDataResult, PageChangeEvent } from '@progress/kendo-angular-grid';
import { Guid } from 'guid-typescript';
import { FormCanDeactivate } from 'src/app/form-can-deactivate/form-can-deactivate.component';
import { DocumentComponent } from 'src/app/common/components/document/document.component';
import { IDocument } from 'src/app/interface/IDocument';
import { CommonService } from 'src/app/service/common/common.service';
import { AwardInfoService } from 'src/app/service/award-information/award-info.service';
import { CommonUtil } from 'src/app/common/common.util';
import { NotificationService } from '@progress/kendo-angular-notification';
import { TabStripComponent } from '@progress/kendo-angular-layout/dist/es2015/main';
import * as $ from 'jquery';
import { environment } from 'src/environments/environment';
import { DeliverableEntryComponent } from '../deliverable-entry/deliverable-entry.component';
import { PriorApprovalsComponent } from '../prior-approvals/prior-approvals.component';
import { NotesComponent } from '../notes/notes.component';

const flatten = filter => {
  const filters = (filter || {}).filters;
  if (filters) {
    return filters.reduce((acc, curr) => acc.concat(curr.filters ? flatten(curr) : [curr]), []);
  }
  return [];
};

const distinctName = data => data.map(x => x)
  .filter((x, idx, xs) => xs.findIndex(y => y.name === x.name) === idx);

const distinctTitle = data => data.map(x => x)
  .filter((x, idx, xs) => xs.findIndex(y => y.title === x.title) === idx);

const distinctEmail = data => data.map(x => x)
  .filter((x, idx, xs) => xs.findIndex(y => y.email === x.email) === idx);

const distinctCountry = data => data.map(x => x)
  .filter((x, idx, xs) => xs.findIndex(y => y.name === x.name) === idx);

const distinctManager = data => data.map(x => x)
  .filter((x, idx, xs) => xs.findIndex(y => y.displayName === x.displayName) === idx);

const distinctActivity = data => data.map(x => x)
  .filter((x, idx, xs) => xs.findIndex(y => y.activityName === x.activityName) === idx);

@Component({
  selector: 'app-award-information-entry',
  templateUrl: './award-information-entry.component.html',
  styleUrls: ['./award-information-entry.component.scss']
})
export class AwardInformationEntryComponent extends FormCanDeactivate implements OnInit, OnDestroy {
  public roles: string = '';

  constructor(private dialogService: DialogService, private commonService: CommonService,
              private router: Router, private awardInfoService: AwardInfoService,
              private activatedRoute: ActivatedRoute, private formBuilder: FormBuilder,
              private notificationService: NotificationService) {
              super();
              this.roles = localStorage.getItem('roles');
            }

  @ViewChild('ngFormDirtyCheck') ngFormDirtyCheck: NgForm; // for dirty check
  @ViewChild(DocumentComponent) documentComponent: DocumentComponent;
  @ViewChild(DeliverableEntryComponent) deliverableComponent: DeliverableEntryComponent;
  @ViewChild(PriorApprovalsComponent) priorApprovalsComponent: PriorApprovalsComponent;
  @ViewChild(NotesComponent) notesComponent: NotesComponent;
  @ViewChild('tabstrip') tabstrip: TabStripComponent;

  public pageTitle: any = '';
  public defaultGuid: string = '00000000-0000-0000-0000-000000000000';
  public donorContactGrid: GridDataResult;
  public countryImplementationGrid: GridDataResult;
  public mySelection: string[] = [];
  public countryList: IKeyPairValue[] = [];
  public getAllCountryList: IKeyPairValue[] = [];
  public countryOriginalList: IKeyPairValue[] = [];
  public contactList: IKeyPairValue[] = [];
  public contactOriginalList: IKeyPairValue[] = [];
  public allUsersOriginalList: IKeyPairValue[] = [];
  public allUsersList: IKeyPairValue[] = [];
  public activityManagersOriginalList: IKeyPairValue[] = [];
  public activityManagersList: IKeyPairValue[] = [];
  public donorAgencyList: IKeyPairValue[] = [];
  public donorAgencyOriginalList: IKeyPairValue[] = [];
  public agreementStatusList: IKeyPairValue[] = [];
  public agreementStatusOriginalList: IKeyPairValue[] = [];
  public regionList: IKeyPairValue[] = [];
  public regionOriginalList: IKeyPairValue[] = [];
  public technicalAreaList: IKeyPairValue[] = [];
  public technicalAreaOriginalLis: IKeyPairValue[] = [];
  public enablePrimeFunder: boolean = false;
  public hasMultipleYear: boolean = false;
  public newCountryName: string = '';
  public validateNewCountryName: boolean = false;
  public validateNewRegion: boolean = false;
  public newRegion: string = '';
  public dialogRef: DialogRef = new DialogRef();
  public awardInfoHeader: IAwardInfoHeader = {};
  public awardDetails: IAwardInfoHeader = {};
  public agreementDetails: IAwardDetails = {};
  public agreementDonorContact: IDonorContact[] = [];
  public agreementTechnicalArea: ITechnicalArea[] = [];
  public saveTechnicalArea: ITechnicalArea[] = [];
  public agreementCountry: IAwardCountry[] = [];
  public agreementRegion: IAwardCountry[] = [];
  public deleteActivityIds: any[] = [];
  public deleteCountryIds: any[] = [];
  public deleteRegionIds: any[] = [];
  public deleteTechnicalAreaIds: any[] = [];
  public deleteDonorContactIds: any[] = [];
  public agreementId: any = '';
  public donorId: any = '';
  public donorContacts: any[] = [];
  public donorContactLists: any[] = [];
  public agreementDonorContacts: IDonorContact[] = [];
  public agreementDonorContactList: IDonorContact[] = [];
  public agreementcontact: IDonorContact = {};
  public agreementCountryDetails: IAwardCountry = {};
  public agreementCountryList: IAwardCountry[] = [];
  public activityCountryList: any[] = [];
  public agreementRegionList: IAwardCountry[] = [];
  public projectStartDateValid: boolean = false;
  public projectDateRangeValid: boolean = false;
  public donorAgencyValidate: boolean = false;
  public awardTitleValidate: boolean = false;
  public awardNumberValidate: boolean = false;
  public awardNickNameValidate: boolean = false;
  public awardStatusValidate: boolean = false;
  public validAwardSave: boolean = false;
  public saveFlag: boolean = false;
  public primeFunderValidate: boolean = false;
  public agreementYearValidate: boolean = false;
  public startDate: Date = new Date();
  public endDate: Date = new Date();
  public isEnableDonorContactList: boolean = false;
  public showCountryOfImplementSection: boolean = false;
  public activities: Array<string> = [];
  public selectedActivities: Array<string> = [];
  public agreementActivities: IActivity[] = [];
  public postAgreementActivities: IActivity[] = [];
  public selectedCountryItems: any[] = [];
  public selectedCountryIdsForRegion: any[] = [];
  public awardEntryForm: FormGroup;
  public newRegionTempForm: FormGroup;
  public allCountryList: IKeyPairValue[] = [];
  public allCountryOriginalList: IKeyPairValue[] = [];
  public allRegionCountryList: IKeyPairValue[] = [];
  public selectedNewCountryItems: any[] = [];
  public selectedNewRegionItems: any[] = [];
  public selectedRegionCountry: any = '';
  public validateRegionCountry: boolean = false;
  public regionCountryList: any[] = [];
  public selectedPage: any = 0;
  public targetPage: any;
  public componentName: string;
  public isDirtyCheck: string;
  public projectStartDate: Date = new Date();
  public projectEndDate: Date = new Date();
  public invalidEmailFormat: boolean = false;
  public isAdminCheck: boolean = false;
  public isDisableAwardNumber: boolean = false;
  public getAwardYear: any = '';
  // Country of Implementation
  public countryOfImplementation: ICOISave[] = [];
  public selectedCountryOfImplementation: ICOISave = {};
  public deleteCountryImplementationIds: any[] = [];
  public formGroup: FormGroup;
  private editedRowIndex: number;
  public countryOfImplementationList: ICOISave[] = [];
  private counter: number = this.countryOfImplementationList.length;
  public activityList: IKeyPairValue[] = [];
  public activityOriginalList: IKeyPairValue[] = [];
  public isReadOnlyPage: boolean = false;
  // Pagination
  public donorContactGridPageSize = 10;
  public countryImplementationGridPageSize = 10;
  public skip = 0;
  public typedg: 'numeric' | 'input' = 'numeric';
  public buttonCount = 5;
  public info = true;
  public pageSizes = true;
  public previousNext = true;
  public text: string = '';
  public enteredSearchText: string = '';
  public reqstate: State = {
    skip: 0,
    take: 10
  };
  public selectedCountry: string = '';
  public filter?: CompositeFilterDescriptor;
  public filteredData: any = [];
  public newDonorContactName: string = '';
  public newDonorContactTitle: string = '';
  public newDonorContactEmail: string = '';
  public newDonorContactNotes: string = '';
  public validDonorContactName: boolean = false;
  public validDonorContactTitle: boolean = false;
  public validDonorContactEmail: boolean = false;
  public guidId: any = '';
  public countryGuidId: any = '';
  public regionGuidId: any = '';
  public awardNumber: any = '';
  public agreementYear: any = '';
  public awardNickName: any = '';
  public awardTitle: any = '';
  public documentExpandFlag: boolean = false;
  public validateDocumentExpandFlag: boolean = false;
  public uploadFileList: IDocument[] = [];
  private intervaltime;
  public isDocumentEmitTrue: boolean = false;
  // Donor POC grid filter
  public categoryFilter: any[] = [];
  public nameValue: any[] = [];
  public titleValue: any[] = [];
  public emailValue: any[] = [];
  // Country implementation grid filter
  public countryValue: any[] = [];
  public managerValue: any[] = [];
  public activityValue: any[] = [];

  donorContactGridPageChange({ skip, take }: PageChangeEvent): void {
    this.skip = skip;
    this.donorContactGridPageSize = take;
  }

  countryImplementationGridPageChange({ skip, take }: PageChangeEvent): void {
    this.skip = skip;
    this.countryImplementationGridPageSize = take;
  }

  donorContactFilterChange(filter: CompositeFilterDescriptor): void {
    this.filter = filter;
    const filterData = filterBy(this.agreementDonorContactList, filter);
    this.donorContactGrid = process(filterData, this.reqstate);
  }

  donorContactDataStateChange(state: DataStateChangeEvent): void {
    this.reqstate = state;
    this.donorContactGrid = process(this.agreementDonorContactList, this.reqstate);
  }

  countryImplementationFilterChange(filter: CompositeFilterDescriptor): void {
    this.filter = filter;
    const filterData = filterBy(this.countryOfImplementationList, filter);
    this.countryImplementationGrid = process(filterData, this.reqstate);
  }

  countryImplementationDataStateChange(state: DataStateChangeEvent): void {
    this.reqstate = state;
    this.countryImplementationGrid = process(this.countryOfImplementationList, this.reqstate);
  }


  ngOnInit(): void {
    this.componentName = 'awardEntryComponent';
    this.initializeFormControls();
    this.getAdminCheck(),
    this.getQueryParams();
    this.getCountry();
    this.getContact();
    this.getDonorAgency();
    this.getAgreementStatus();
    this.getTechnicalArea();
    this.getActivity();
    this.getAllUsers();
    if (this.agreementId) {
      this.isDisableAwardNumber = true;
      this.getAgreementDetails();
      this.getAgreementRegionCountry();
    } else {
      // To set the default as Active.
      this.awardEntryForm.patchValue({ awardStatus: 1 });
      this.isReadOnlyPage = false;
    }
    if (+environment.isAutoSaveEnableFlag === 1) {
      this.autoSave();
    }
  }

  // Initialize Form Controls
  initializeFormControls() {
    this.awardEntryForm = this.formBuilder.group({
      donorAgency: new FormControl(''),
      donorAwardNumber: new FormControl(null),
      awardTitle: new FormControl(null),
      projectStartDate: new FormControl(null),
      projectCloseDate: new FormControl(null),
      subToAnotherOrganization: new FormControl(null),
      primeFunder: new FormControl(null),
      multiYearProject: new FormControl(null),
      agreementYear: new FormControl(null),
      awardStatus: new FormControl(null),
      egpafProjectManager: new FormControl(null),
      egpafAwardManager: new FormControl(null),
      projectSponsor: new FormControl(null),
      researchPOC: new FormControl(null),
      acOfficer: new FormControl(null),
      facsOfficer: new FormControl(null),
      countryProgramOfficer: new FormControl(null),
      researchStudiesConducted: new FormControl(null),
      approvedAsNonResearch: new FormControl(null),
      institutionalReviewBoard: new FormControl(null),
      baseCountry: new FormControl(null),
      baseRegion: new FormControl(null),
      projectYearStartDate: new FormControl(null),
      summaryText: new FormControl(null),
      donorContact: new FormControl(null),
      technicalArea: new FormControl(null),
      baseActivity: new FormControl(null),
      dialogDocumentType: new FormControl(null),
      egpafAwardNumber: new FormControl(null),
      nickName: new FormControl(null),
      donorPOC: new FormControl(null),
      cOICountry: new FormControl(''),
      cOIManager: new FormControl(''),
      activityName: new FormControl('')
    });

    // new region template form
    this.newRegionTempForm = this.formBuilder.group({
      newRegionCountryList: new FormControl(null),
      newRegion: new FormControl(null),
    });
  }

  getAdminCheck() {
    this.commonService.getAdminCheck().subscribe((res) => {
      if (res) {
        this.isAdminCheck = res;
        this.isReadOnlyPageCheck();
      }
    });
  }
  getQueryParams(): void {
    this.activatedRoute.queryParams.subscribe(params => {
      if (params) {
        this.agreementId = params.id;
      }
    });
  }

  getCountry() {
    this.commonService.getCountry().subscribe((response) => {
      this.countryOriginalList = response;
      this.countryList = this.countryOriginalList.slice();
      this.getAllCountryList = this.countryOriginalList.slice();
    });
  }

  getContact() {
    this.commonService.getContact().subscribe((response) => {
      this.contactOriginalList = response;
      if (this.contactOriginalList.length > 0) {
        this.contactOriginalList = this.contactOriginalList.filter((x) => x.name !== null);
        this.contactOriginalList.forEach((element: any) => {
          element.contactName = element.name;
        });
        this.contactList = this.contactOriginalList.slice();
      }
    });
  }

  getDonorAgency() {
    this.commonService.getDonorAgency().subscribe((response) => {
      this.donorAgencyOriginalList = response;
      this.donorAgencyList = this.donorAgencyOriginalList.slice();
    });
  }

  getAgreementStatus() {
    this.commonService.getAgreementStatus().subscribe((response) => {
      this.agreementStatusOriginalList = response;
      this.agreementStatusList = this.agreementStatusOriginalList.slice();
    });
  }

  getTechnicalArea() {
    this.commonService.getTechnicalArea().subscribe((response) => {
      this.technicalAreaOriginalLis = response;
      this.technicalAreaList = this.technicalAreaOriginalLis.slice();
    });
  }

  documentEmit(agreementId: string) {
    if (agreementId === this.defaultGuid) {
      const element: HTMLElement = document.getElementById('submitBtn') as HTMLElement;
      element.click();
      this.setAwardInformationHeader();
    } else {
      if (this.documentComponent.isOverrideDocument === false) {
        this.isDocumentEmitTrue = true;
        this.saveDocuments();
      }
      this.routeAfterDocumentSave();
    }
  }

  getActivity() {
    this.commonService.getActivity().subscribe((response) => {
      this.activityOriginalList = response;
      this.activityList = this.activityOriginalList.slice();
    });
  }

  getAllUsers() {
    this.commonService.getAllUsers().subscribe((response) => {
      this.allUsersOriginalList = response;
      this.allUsersList = this.allUsersOriginalList.slice();
    });
  }

  getDonorContacts(donorId: any) {
    this.commonService.getDonorContacts(donorId).subscribe((response: any) => {
      this.donorContactLists = response;
      this.donorContactLists = this.donorContactLists.filter((x) => x.name !== null);
      this.donorContacts = [];
      this.donorContacts = this.donorContactLists.slice();
    });
  }

  // Get Agreement region with country
  getAgreementRegionCountry() {
    this.awardInfoService.getRegionCountry(this.agreementId).subscribe((response) => {
      this.allRegionCountryList = response;
    });
  }

  // Get Document details
  getDocumentDetails() {
    const getDocumentList: IDocument = {};
    getDocumentList.agreementId = this.agreementId;
    getDocumentList.deliverableDetailId = null;
    getDocumentList.deliverableId = null;
    getDocumentList.agreementPriorApprovalId = null;
    getDocumentList.financialInformationId = null;
    getDocumentList.agreementNoteId = null;
    getDocumentList.isAllDocument = false;
    this.commonService.getDocument(getDocumentList).subscribe((response) => {
      this.uploadFileList = response.Documents;
      if (this.uploadFileList && this.uploadFileList.length > 0) {
        this.documentExpandFlag = true;
        this.validateDocumentExpandFlag = true;
      }
    });
  }

  // Get Agreement Information API
  getAgreementDetails() {
    Common.loader('show');
    this.awardInfoService.getAgreementInformationDetails(this.agreementId).subscribe((response) => {
      if (response) {
        this.agreementDetails = response.Detail[0];
        this.agreementCountry = response.CountryOffice;
        this.agreementRegion = response.Region;
        this.agreementDonorContact = response.AgreementDonorContact;
        this.countryOfImplementation = response.CountryOfImplementation;
        this.agreementTechnicalArea = response.TechnicalArea;
        this.agreementId = this.agreementDetails.id;
        this.donorId = this.agreementDetails.donorId;
        if (this.donorId) {
          this.getDonorContacts(this.donorId);
        }
        this.constructAgreementDonorContact();
        this.constructCountryOffice();
        this.constructTechnicalArea();
        this.donorId = this.agreementDetails.donorId ? this.agreementDetails.donorId : this.defaultGuid;
        this.startDate = this.agreementDetails.projectStartDate ?
          CommonUtil.UTCToLocal(this.agreementDetails.projectStartDate) : null;
        this.endDate = this.agreementDetails.projectClosingDate ?
          CommonUtil.UTCToLocal(this.agreementDetails.projectClosingDate) : null;
        this.awardEntryForm.patchValue({ donorAgency: this.donorId });
        this.awardEntryForm.patchValue({ donorAwardNumber: this.agreementDetails.donorAwardNumber });
        this.awardEntryForm.patchValue({ egpafAwardNumber: this.agreementDetails.egpafAwardNumber });
        this.awardEntryForm.patchValue({ awardTitle: this.agreementDetails.title });
        this.awardNickName = this.agreementDetails.nickName;
        this.awardTitle = this.agreementDetails.title;
        this.awardNumber = this.agreementDetails.egpafAwardNumber;
        this.awardEntryForm.patchValue({ nickName: this.agreementDetails.nickName });
        this.pageTitle = this.agreementDetails.title;
        this.awardEntryForm.patchValue({ pageTitle: this.agreementDetails.title });
        this.awardEntryForm.patchValue({ projectStartDate: this.startDate });
        this.awardEntryForm.patchValue({ projectCloseDate: this.endDate });
        if (this.agreementDetails.hasSubOrganization === true) {
          this.awardEntryForm.patchValue({ subToAnotherOrganization: 'Yes' });
          this.enablePrimeFunder = true;
          this.awardEntryForm.patchValue({ primeFunder: this.agreementDetails.primeFunder });
        } else if (this.agreementDetails.hasSubOrganization === false) {
          this.awardEntryForm.patchValue({ subToAnotherOrganization: 'No' });
        }
        if (this.agreementDetails.isMultiYear === true) {
          this.awardEntryForm.patchValue({ multiYearProject: 'Yes' });
          this.hasMultipleYear = true;
          this.awardEntryForm.patchValue({ agreementYear: this.agreementDetails.agreementYear });
          this.getAwardYear = this.agreementDetails.agreementYear;
          this.agreementYear = this.agreementDetails.agreementYear;
          localStorage.setItem('awardAgreementYear', this.agreementYear);
        } else if (this.agreementDetails.isMultiYear === false) {
          this.awardEntryForm.patchValue({ multiYearProject: 'No' });
          this.agreementYear = '';
          localStorage.setItem('awardAgreementYear', this.agreementYear);
        }
        this.awardEntryForm.patchValue({ awardStatus: this.agreementDetails.agreementStatusId });
        this.isReadOnlyPageCheck();
        this.awardEntryForm.patchValue({ egpafProjectManager: this.agreementDetails.projectManagerId });
        this.awardEntryForm.patchValue({ egpafAwardManager: this.agreementDetails.egpafAgreementManagerId });
        this.awardEntryForm.patchValue({ acOfficer: this.agreementDetails.acOfficerId });
        this.awardEntryForm.patchValue({ facsOfficer: this.agreementDetails.facsOfficerId });
        this.awardEntryForm.patchValue({ researchPOC: this.agreementDetails.researchPOCId });
        this.awardEntryForm.patchValue({ donorPOC: this.agreementDetails.donorPOCId });
        if (this.agreementDetails.hasNRDApproval === true) {
          this.awardEntryForm.patchValue({ approvedAsNonResearch: 'Yes' });
        } else if (this.agreementDetails.hasNRDApproval === false) {
          this.awardEntryForm.patchValue({ approvedAsNonResearch: 'No' });
        }
        if (this.agreementDetails.hasIRB === true) {
          this.awardEntryForm.patchValue({ institutionalReviewBoard: 'Yes' });
        } else if (this.agreementDetails.hasIRB === false) {
          this.awardEntryForm.patchValue({ institutionalReviewBoard: 'No' });
        }
        if (this.agreementDetails.isResearchRequired === true) {
          this.awardEntryForm.patchValue({ researchStudiesConducted: 'Yes' });
        } else if (this.agreementDetails.isResearchRequired === false) {
          this.awardEntryForm.patchValue({ researchStudiesConducted: 'No' });
        }
        this.awardEntryForm.patchValue({ projectSponsor: this.agreementDetails.projectSponsorId });
        this.awardEntryForm.patchValue({ countryProgramOfficer: this.agreementDetails.countryProgramOfficerId });
        this.awardEntryForm.patchValue({ summaryText: this.agreementDetails.summary });
        this.agreementActivities = response.Activity;
        // Activity
        let selectedactivityNames: any[] = [];
        selectedactivityNames = this.agreementActivities.map(a => a.activityName);
        this.activities = selectedactivityNames;
        this.selectedActivities = selectedactivityNames;
        this.awardEntryForm.patchValue({ baseActivity: selectedactivityNames });
        // Country Of Implementation
        this.constructCountryOfImplementation();
        this.getDocumentDetails();
      }
      Common.loader('hide');
    });
  }

  isReadOnlyPageCheck() {
    if (this.agreementDetails.agreementStatusId === 2 || this.roles === 'Observer' ||
      (this.agreementDetails.agreementStatusId === 4 && this.isAdminCheck === false)) {
      this.isReadOnlyPage = true;
    } else {
      this.isReadOnlyPage = false;
    }
  }

  constructAgreementDonorContact() {
    this.commonService.getDonorContacts(this.donorId).subscribe((response: any) => {
      this.donorContacts = [];
      this.donorContacts = response;
      if (this.agreementDonorContact.length > 0) {
        this.isEnableDonorContactList = true;
        const selectedDonorContactItems: any[] = [];
        this.agreementDonorContact.forEach((res: any) => {
          this.donorContacts.forEach((list) => {
            if (res && list && list.donorContactId === res.donorContactId) {
              selectedDonorContactItems.push(list.contactId);
            }
          });
        });
        this.awardEntryForm.patchValue({ donorContact: selectedDonorContactItems });
        this.agreementDonorContactList = this.agreementDonorContact;
        this.donorContactGrid = process(this.agreementDonorContactList, this.reqstate);
        this.agreementDonorContacts = this.agreementDonorContact;
        this.nameValue = distinctName(this.agreementDonorContactList.filter((x) => x.name !== ''));
        this.titleValue = distinctTitle(this.agreementDonorContactList.filter((x) => x.title !== ''));
        this.emailValue = distinctEmail(this.agreementDonorContactList.filter((x) => x.email !== ''));
      }
    });
  }

  constructCountryOffice() {
    this.awardInfoService.getAllCountry(this.agreementId).subscribe((res: any) => {
      this.allCountryList = res;
      this.regionCountryList = res;
      this.regionCountryList.forEach((regionCountry: any) => {
        regionCountry.countryRegionName = regionCountry.countryName;
      });
      if (this.allCountryList.length > 0) {
        this.allCountryList.forEach((getList: any) => {
          this.countryList.forEach((list) => {
            if (getList && list && list.countryOfficeId === getList.countryOfficeId) {
              const constructActivityCountryList: any = {};
              constructActivityCountryList.countryRegionName = getList.countryRegionName;
              constructActivityCountryList.countryOfficeId = getList.countryOfficeId;
              this.activityCountryList.push(constructActivityCountryList);
              this.selectedCountryItems.push(list.countryOfficeId);
              this.selectedNewCountryItems.push(list.countryOfficeId); // to check
              this.selectedCountryIdsForRegion.push(list.countryOfficeId);
            }
          });
        });
        this.awardEntryForm.patchValue({ baseCountry: this.selectedCountryItems });
        this.constructRegion();
      }
      this.setActivityCountry();
    });
  }

  constructRegion() {
    this.commonService.getRegion(this.selectedCountryIdsForRegion).subscribe((res: any) => {
      this.regionOriginalList = res;
      this.regionList = this.regionOriginalList.slice();
      if (this.allRegionCountryList.length > 0) {
        const selectedRegion: any[] = [];
        this.allRegionCountryList.forEach((getRegionList: any) => {
          selectedRegion.push(getRegionList.regionId);
          this.selectedNewRegionItems.push(getRegionList.regionId); // to check
        });
        this.awardEntryForm.patchValue({ baseRegion: selectedRegion });
      }
    });
  }

  constructTechnicalArea() {
    this.commonService.getTechnicalArea().subscribe((response) => {
      this.technicalAreaList = response;
      if (this.agreementTechnicalArea.length > 0) {
        const selectedArea: any[] = [];
        this.agreementTechnicalArea.forEach((getAreaList: any) => {
          selectedArea.push(getAreaList.technicalAreaId);
        });
        this.awardEntryForm.patchValue({ technicalArea: selectedArea });
      }
    });
  }

  constructActivity() {
    if (this.agreementActivities.length > 0) {
      const selectedActivity: any[] = [];
      this.agreementActivities.forEach((list: any) => {
        selectedActivity.push(list.ActivityName);
      });
      this.awardEntryForm.patchValue({ baseActivity: selectedActivity });
    }
  }

  constructCountryOfImplementation() {
    if (this.countryOfImplementation.length > 0) {
      this.showCountryOfImplementSection = true;
      this.countryOfImplementation.forEach((getList: any) => {
        getList.name = getList.countryName;
        getList.userId = getList.managerId;
        getList.displayName = getList.managerName;
      });
      this.countryOfImplementationList = this.countryOfImplementation;
      this.countryImplementationGrid = process(this.countryOfImplementationList, this.reqstate);
      this.countryValue = distinctCountry(this.countryOfImplementationList.filter((x) => x.name !== ''));
      this.managerValue = distinctManager(this.countryOfImplementationList.filter((x) => x.displayName !== ''));
      this.activityValue = distinctActivity(this.countryOfImplementationList.filter((x) => x.activityName !== ''));
    }
  }

  // numeric validation
  isNumericAndMaxLength(event: any) {
    const pattern = /[0-9]/;
    const inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  isAwardYearUsed(event: any) {
    const inputChar = event;
    if (this.agreementYear !== '') {
      this.awardInfoService.getIsAwardYearUsed(this.agreementId, inputChar, this.getAwardYear).subscribe((resp: any) => {
        if (resp === true) {
          this.dialogRef = this.dialogService.open({
            title: 'Information',
            content: 'Award year already mapped with other records',
            actions: [
              { text: 'Ok', primary: true }
            ],
            width: 400,
          });
          this.dialogRef.result.subscribe((rs: any) => {
            if (rs instanceof DialogCloseResult) {
              this.awardEntryForm.patchValue({ agreementYear: this.getAwardYear });
            }
            if (rs.text && rs.text === 'Ok') {
              this.awardEntryForm.patchValue({ agreementYear: this.getAwardYear });
            }
          });
        }
      });
    }
  }

  // Dropdown Filter Start
  public handleCountries(value: any) {
    if (value.length >= 1) {
      this.countryList = this.countryOriginalList.filter((s) => s.name.toLowerCase().indexOf(value.toLowerCase()) !== -1);
    } else {
      this.countryList = this.countryOriginalList;
    }
  }

  public handleAwardStatus(value: any) {
    if (value.length >= 1) {
      this.agreementStatusList = this.agreementStatusOriginalList.filter(
        (s) => s.statusName.toLowerCase().indexOf(value.toLowerCase()) !== -1);
    } else {
      this.agreementStatusList = this.agreementStatusOriginalList;
    }
  }

  public handleDonorAgency(value: any) {
    if (value.length >= 1) {
      this.donorAgencyList = this.donorAgencyOriginalList.filter((s) => s.agencyName.toLowerCase().indexOf(value.toLowerCase()) !== -1);
    } else {
      this.donorAgencyList = this.donorAgencyOriginalList;
    }
  }

  public handleAllUsersList(value: any) {
    if (value.length >= 1) {
      this.allUsersList = this.allUsersOriginalList.filter((s) => s.displayName.toLowerCase().indexOf(value.toLowerCase()) !== -1);
    } else {
      this.allUsersList = this.allUsersOriginalList;
    }
  }

  public handleDonorContact(value: any) {
    if (value.length >= 1) {
      this.contactList = this.contactOriginalList.filter((s) => s.name.toLowerCase().indexOf(value.toLowerCase()) !== -1);
    } else {
      this.contactList = this.contactOriginalList;
    }
  }

  public handleImplementationManager(value: any) {
    if (value.length >= 1) {
      // tslint:disable-next-line: max-line-length
      this.activityManagersList = this.activityManagersOriginalList.filter((s) => s.displayName.toLowerCase().indexOf(value.toLowerCase()) !== -1);
    } else {
      this.activityManagersList = this.activityManagersOriginalList;
    }
  }

  public handleRegions(value: any) {
    if (value.length >= 1) {
      this.regionList = this.regionOriginalList.filter((s) => s.countryRegionName.toLowerCase().indexOf(value.toLowerCase()) !== -1);
    } else {
      this.regionList = this.regionOriginalList;
    }
  }

  public handleTechnicalAreas(value: any) {
    if (value.length >= 1) {
      this.technicalAreaList = this.technicalAreaOriginalLis.filter((s) => s.description.toLowerCase().indexOf(value.toLowerCase()) !== -1);
    } else {
      this.technicalAreaList = this.technicalAreaOriginalLis;
    }
  }
  //  Dropdown Filter End

  // To create new DonorContact temp Start
  public createNewDonorContact(template: TemplateRef<any>) {
    this.validDonorContactName = false;
    this.validDonorContactTitle = false;
    this.validDonorContactEmail = false;
    this.dialogRef = this.dialogService.open({
      title: 'Add Donor Contact Information',
      content: template,
      minWidth: 800
    });
    this.dialogRef.result.subscribe();
  }

  public donorContactNameChange(event: any) {
    this.newDonorContactName = event.target.value;
  }

  public donorContactTitleChange(event: any) {
    this.newDonorContactTitle = event.target.value;
  }

  public donorContactEmailChange(event: any) {
    this.newDonorContactEmail = event.target.value;
  }

  // public donorContactNotesChange(event: any) {
  //   this.newDonorContactNotes = event.target.value;
  // }

  public manualyAddedDonorContact() {
    if (this.validateNewlyAddedDonorContacts()) {
      const newDonorContactList: any = {};
      this.guidId = Guid.create();
      newDonorContactList.contactId = this.guidId.value;
      newDonorContactList.name = this.newDonorContactName;
      newDonorContactList.email = this.newDonorContactEmail;
      newDonorContactList.title = this.newDonorContactTitle;
      // newDonorContactList.note = this.newDonorContactNotes;
      this.donorContacts.push(newDonorContactList);
      this.dialogRef.close();
    }
  }

  public validateNewlyAddedDonorContacts() {
    this.validDonorContactName = this.newDonorContactName ? false : true;
    this.validDonorContactTitle = this.newDonorContactTitle ? false : true;
    if (this.newDonorContactEmail) {
      if (this.commonService.isValidEmail(this.newDonorContactEmail)) {
        this.invalidEmailFormat = false;
      } else {
        this.invalidEmailFormat = true;
        this.validDonorContactEmail = false;
      }
    } else {
      this.validDonorContactEmail = this.newDonorContactEmail ? false : true;
    }
    if (!this.validDonorContactName && !this.validDonorContactTitle && !this.validDonorContactEmail && !this.invalidEmailFormat) {
      return true;
    } else {
      return false;
    }
  }
  // To create new DonorContact temp end

  // To create new country from UI
  public createNewCountry(template: TemplateRef<any>) {
    this.dialogRef = this.dialogService.open({
      title: 'Add Country',
      content: template,
      minWidth: 350
    });
    this.dialogRef.result.subscribe();
  }

  public countryNameChange(event: any) {
    this.newCountryName = event.target.value;
  }

  public addCountry() {
    if (this.validateCountryName()) {
      const newCountry: any = {};
      this.countryGuidId = Guid.create();
      newCountry.countryOfficeId = this.countryGuidId.value;
      newCountry.name = this.newCountryName;
      newCountry.countryRegionName = this.newCountryName;
      this.countryList.push(newCountry);
      this.regionCountryList.push(newCountry);
      this.activityCountryList.push(newCountry);
      this.selectedNewCountryItems.push(newCountry.countryOfficeId);
      this.awardEntryForm.patchValue({ baseCountry: this.selectedNewCountryItems });
      // for API save
      const tempNewCountry: any = {};
      tempNewCountry.id = this.defaultGuid;
      tempNewCountry.agreementId = this.agreementId;
      tempNewCountry.countryOfficeId = null;
      tempNewCountry.other = this.newCountryName;
      tempNewCountry.countryRegionName = this.newCountryName;
      this.agreementCountryList.push(tempNewCountry);
      this.dialogRef.close();
    }
  }

  public validateCountryName() {
    this.validateNewCountryName = this.newCountryName ? false : true;
    if (!this.validateNewCountryName) {
      return true;
    } else {
      return false;
    }
  }
  // To create new country from UI end


  // To create new region from UI
  public createNewRegion(template: TemplateRef<any>) {
    this.newRegionTempForm.patchValue({ newRegionCountryList: null });
    this.dialogRef = this.dialogService.open({
      title: 'Add Region',
      content: template,
      minWidth: 350
    });
    this.dialogRef.result.subscribe();
  }

  public newRegionNameChange(event: any) {
    this.newRegion = event.target.value;
  }

  public addRegion() {
    if (this.validateRegion()) {
      const newRegion: any = {};
      this.regionGuidId = Guid.create();
      newRegion.regionId = this.regionGuidId.value;
      newRegion.countryRegionName = this.newRegion;
      newRegion.countryName = this.selectedRegionCountry.countryRegionName;
      this.regionList.push(newRegion);
      this.selectedNewRegionItems.push(newRegion.regionId);
      this.awardEntryForm.patchValue({ baseRegion: this.selectedNewRegionItems });
      // for API save
      const tempNewRegion: any = {};
      tempNewRegion.id = this.defaultGuid;
      tempNewRegion.agreementId = this.agreementId;
      tempNewRegion.regionId = null;
      tempNewRegion.other = this.newRegion;
      tempNewRegion.countryName = this.selectedRegionCountry.countryRegionName;
      this.agreementRegionList.push(tempNewRegion);
      this.dialogRef.close();
    }
  }

  public regionCountrySelectionChange(event: any) {
    this.selectedRegionCountry = event;
  }

  public validateRegion() {
    this.validateNewRegion = this.newRegion ? false : true;
    this.validateRegionCountry = this.selectedRegionCountry ? false : true;
    if (!this.validateNewRegion && !this.validateRegionCountry) {
      return true;
    } else {
      return false;
    }
  }

  public technicalAreaSelectionChange(event: any) {
    if (event.length > 0) {
      this.saveTechnicalArea = [];
      event.forEach((element: ITechnicalArea) => {
        const saveArea: ITechnicalArea = {};
        let agreementTechnical: any = this.agreementTechnicalArea.find((el) => el.technicalAreaId === element);
        if (agreementTechnical) {
          saveArea.technicalAreaId = agreementTechnical.technicalAreaId;
          saveArea.id = agreementTechnical.id ? agreementTechnical.id : this.defaultGuid;
        } else {
          agreementTechnical = this.technicalAreaOriginalLis.find((el) => el.technicalAreaId === element);
          saveArea.technicalAreaId = agreementTechnical.technicalAreaId;
        }
        this.saveTechnicalArea.push(saveArea);
      });
    } else {
      if (this.agreementTechnicalArea.length > 0) {
        this.agreementTechnicalArea.forEach((ele) => {
          if (ele.id) {
            this.deleteTechnicalAreaIds.push(ele.id)
          }
        })
      }
      if (this.saveTechnicalArea.length > 0) {
        this.saveTechnicalArea = [];
      }
    }
  }

  public countrySelectionChange(event: any) {
    const countryIds = [];
    if (event.length > 0) {
      event.forEach((element: any) => {
        if (/^\d+$/.test(element)) {
          countryIds.push(element);
        }
      });
      this.commonService.getRegion(countryIds).subscribe((resp: any) => {
        this.regionOriginalList = resp;
        this.regionList = this.regionOriginalList.slice();
      });
      this.agreementCountryList = [];
      this.regionCountryList = [];
      this.selectedNewCountryItems = [];
      this.activityCountryList = [];
      const countryList = event;
      countryList.forEach((element: any) => {
        if (/^\d+$/.test(element)) {
          this.getAllCountryList.forEach((list: any) => {
            if (element === list.countryOfficeId) {
              const countryInfo = this.agreementCountry.find((el) => el.countryOfficeId === element);
              const agreementCountry: IAwardCountry = {};
              if (countryInfo) {
                agreementCountry.id = countryInfo.id;
                agreementCountry.countryOfficeId = element;
                agreementCountry.countryRegionName = countryInfo.name;
              } else {
                agreementCountry.id = this.defaultGuid;
                agreementCountry.countryOfficeId = element;
                agreementCountry.countryRegionName = list.name;
              }
              this.agreementCountryList.push(agreementCountry);
              this.regionCountryList.push(agreementCountry);
              this.activityCountryList.push(agreementCountry);
              this.selectedNewCountryItems.push(agreementCountry.countryOfficeId);
            }
          });
        } else {
          this.countryList.forEach((allContryList: any) => {
            if (allContryList.countryOfficeId === element) {
              const newCountry: any = {};
              newCountry.id = this.defaultGuid;
              newCountry.agreementId = this.agreementId;
              newCountry.countryOfficeId = null;
              newCountry.other = allContryList.countryRegionName;
              newCountry.countryRegionName = allContryList.countryRegionName;
              this.agreementCountryList.push(newCountry);
              this.regionCountryList.push(newCountry);
              this.activityCountryList.push(newCountry);
              this.selectedNewCountryItems.push(allContryList.countryOfficeId);
            }
          });
        }
      });
    } else {
      this.activityCountryList = [];
      this.setActivityCountry();
    }
  }

  public regionSelectionChange(event: any) {
    if (event.length > 0) {
      this.agreementRegionList = [];
      this.selectedNewRegionItems = [];
      const regionList = event;
      regionList.forEach((element: any) => {
        if (/^\d+$/.test(element)) {
          const regionInfo = this.allRegionCountryList.find((el) => el.regionId === element);
          const agreementRegion: IAwardCountry = {};
          if (regionInfo) {
            agreementRegion.id = regionInfo.id;
            agreementRegion.regionId = element;
            this.agreementRegionList.push(agreementRegion);
            this.selectedNewRegionItems.push(agreementRegion.regionId);
          } else {
            agreementRegion.id = this.defaultGuid;
            agreementRegion.regionId = element;
            this.agreementRegionList.push(agreementRegion);
            this.selectedNewRegionItems.push(agreementRegion.regionId);
          }
        } else {
          const tempRegionList = this.regionList.find((el) => el.regionId === element);
          if (tempRegionList) {
            const newRegion: any = {};
            newRegion.id = this.defaultGuid;
            newRegion.agreementId = this.agreementId;
            newRegion.regionId = null;
            newRegion.other = tempRegionList.countryRegionName;
            newRegion.countryName = this.selectedRegionCountry.countryRegionName;
            this.agreementRegionList.push(newRegion);
            this.selectedNewRegionItems.push(newRegion.regionId);
          }
        }
      });
    }
  }

  // set activity country
  public setActivityCountry() {
    if (this.activityCountryList.length === 0) {
      if (this.allCountryList.length > 0) {
        this.countryList.forEach((element: any) => {
          element.countryRegionName = element.name;
        });
        this.activityCountryList = this.countryList;
      }
    }
  }

  // Activity on change even
  public onActivityChange(value: any[]) {
    if (value.length > 0) {
      this.postAgreementActivities = [];
      const activityList = value;
      activityList.forEach((el: any) => {
        const activity: IActivity = {};
        activity.id = this.defaultGuid;
        activity.agreementId = this.agreementId;
        activity.activityId = this.defaultGuid;
        activity.activityName = el;
        // push to the activity list.
        this.postAgreementActivities.push(activity);
      });
      this.selectedActivities = [];
      this.selectedActivities = value;
      this.activities = [];
      this.activities = value;
    }
  }

  public donorSelectionChange(event: any) {
    if (event) {
      this.donorAgencyValidate = false;
      this.donorId = event;
      this.commonService.getDonorContacts(this.donorId).subscribe((response: any) => {
        this.donorContactLists = response;
        this.donorContactLists = this.donorContactLists.filter((x) => x.name !== null);
        this.donorContacts = [];
        this.agreementDonorContactList = [];
        this.agreementDonorContacts.forEach((el) => {
          this.deleteDonorContactIds.push(el.id);
        });
        this.agreementDonorContacts = [];
        this.awardEntryForm.patchValue({ donorContact: '' });
        this.donorContacts = this.donorContactLists.slice();
      });
    }
  }

  public donorContactSelectionChange(event: any) {
    let contactId = null;
    this.agreementDonorContactList = [];
    if (event.length > 0) {
      const selectedContact: any[] = event;
      selectedContact.forEach((element: any) => {
        contactId = element;
        this.mapAgreementDonorContacts(contactId);
      });
    } else {
      this.agreementDonorContacts.forEach((element) => {
        const item = this.agreementDonorContacts.filter((x) => x.contactId === element.contactId);
        item.forEach((ele) => {
          this.deleteDonorContactIds.push(ele?.id);
        });
      });
      this.donorContactGrid = null;
    }
  }

  public mapAgreementDonorContacts(contactId: any) {
    if (contactId && this.donorContacts.length > 0) {
      const donorContact: IDonorContact = {};
      this.agreementcontact = {};
      const contactInfo = this.donorContacts.find((el) => el.contactId === contactId);
      const existContact = this.agreementDonorContacts.find((element) => element.contactId === contactId);
      if (contactInfo.donorContactId) {
        this.agreementcontact.donorContactId = contactInfo?.donorContactId;
        this.agreementcontact.donorId = this.donorId;
        this.agreementcontact.agreementId = this.agreementId;
        this.agreementcontact.contactId = existContact ? existContact.contactId : contactId;
        this.agreementcontact.id = existContact ? existContact.id : this.defaultGuid;
        this.agreementcontact.isPOCCompliance = existContact ? existContact.isPOCCompliance : false;
        this.agreementcontact.isPOCProgrammatic = existContact ? existContact.isPOCProgrammatic : false;
        this.agreementcontact.title = contactInfo?.title;
        this.agreementcontact.email = contactInfo?.email;
        this.agreementcontact.name = contactInfo?.name;
        donorContact.donorId = this.donorId;
        donorContact.name = contactInfo?.name;
        donorContact.title = contactInfo?.title;
        donorContact.email = contactInfo?.name;
        this.agreementcontact.donorContact = {};
        this.agreementcontact.donorContact = donorContact;
        this.agreementDonorContactList.push(this.agreementcontact);
        this.donorContactGrid = process(this.agreementDonorContactList, this.reqstate);
      } else {
        this.agreementcontact.id = this.defaultGuid;
        this.agreementcontact.agreementId = this.agreementId;
        this.agreementcontact.donorContactId = this.defaultGuid;
        this.agreementcontact.contactId = contactId;
        this.agreementcontact.title = contactInfo?.title;
        this.agreementcontact.email = contactInfo?.email;
        this.agreementcontact.name = contactInfo?.name;
        donorContact.donorId = this.donorId;
        donorContact.name = contactInfo?.name;
        donorContact.title = contactInfo?.title;
        donorContact.email = contactInfo?.email;
        donorContact.note = contactInfo?.note;
        this.agreementcontact.donorContact = {};
        this.agreementcontact.donorContact = donorContact;
        this.agreementDonorContactList.push(this.agreementcontact);
        this.donorContactGrid = process(this.agreementDonorContactList, this.reqstate);
        this.dialogRef.close();
      }
    }
  }

  public itemCheck(dataItem: any, event: any, field: any): void {
    const contactItem = this.agreementDonorContactList.find(e => e.contactId === dataItem.contactId);
    const donorContactItem = this.donorContacts.find(e => e.contactId === dataItem.contactId);
    if (contactItem) {
      if (field === 'IsPOCCompliance') {
        contactItem.isPOCCompliance = event.target.checked ? true : false;
        donorContactItem.isPOCCompliance = event.target.checked ? true : false;
      } else if (field === 'IsPOCProgrammatic') {
        contactItem.isPOCProgrammatic = event.target.checked ? true : false;
        donorContactItem.isPOCProgrammatic = event.target.checked ? true : false;
      }
    }
  }

  projectDateChange() {
    this.projectStartDate = this.awardEntryForm.controls.projectStartDate.value ?
      this.awardEntryForm.controls.projectStartDate.value : null;
    this.projectEndDate = this.awardEntryForm.controls.projectCloseDate.value ?
      this.awardEntryForm.controls.projectCloseDate.value : null;
    if (this.projectStartDate > this.projectEndDate) {
      this.projectDateRangeValid = true;
    } else {
      this.projectDateRangeValid = false;
    }
    if (this.projectStartDate === null && this.projectEndDate !== null) {
      this.projectStartDateValid = true;
    } else {
      this.projectStartDateValid = false;
    }
  }

  // Validation for isEmpty
  isEmpty(paramValue: any): boolean {
    if (paramValue === null || paramValue === undefined || paramValue === '') {
      return true;
    } else {
      return false;
    }
  }

  // Validate mandatory fields
  validateSave(): any {
    this.donorAgencyValidate = true;
    this.awardTitleValidate = true;
    this.awardStatusValidate = true;
    this.awardNumberValidate = true;
    this.awardNickNameValidate = true;

    if (this.awardEntryForm.controls.subToAnotherOrganization.value === 'Yes' && this.awardEntryForm.controls.primeFunder.value === null) {
      this.primeFunderValidate = true;
    } else {
      this.primeFunderValidate = false;
    }
    if (this.awardEntryForm.controls.multiYearProject.value === 'Yes' && this.awardEntryForm.controls.agreementYear.value === null) {
      this.agreementYear = this.agreementDetails.agreementYear;
      this.agreementYearValidate = true;
    } else {
      this.agreementYearValidate = false;
    }
    if (!(this.isEmpty(this.awardEntryForm.controls.donorAgency.value))) {
      this.donorAgencyValidate = false;
    }
    if (!(this.isEmpty(this.awardEntryForm.controls.egpafAwardNumber.value))) {
      this.awardNumber = this.awardEntryForm.controls.egpafAwardNumber.value;
      this.awardNumberValidate = false;
    }
    if (!(this.isEmpty(this.awardEntryForm.controls.awardTitle.value))) {
      this.awardTitle = this.awardEntryForm.controls.awardTitle.value;
      this.awardTitleValidate = false;
    }
    if (!(this.isEmpty(this.awardEntryForm.controls.nickName.value))) {
      this.awardNickName = this.awardEntryForm.controls.nickName.value;
      this.awardNickNameValidate = false;
    }
    if (!(this.isEmpty(this.awardEntryForm.controls.awardStatus.value))) {
      this.awardStatusValidate = false;
    }
    if (this.projectStartDate && this.projectEndDate) {
      if (new Date(this.projectStartDate) > new Date(this.projectEndDate)) {
        this.projectDateRangeValid = true;
      } else {
        this.projectDateRangeValid = false;
      }
    } else {
      this.projectDateRangeValid = false;
    }

    if (this.donorAgencyValidate || this.awardTitleValidate || this.awardStatusValidate || this.projectDateRangeValid
      || this.agreementYearValidate || this.primeFunderValidate || this.awardNumberValidate || this.awardNickNameValidate) {
      return this.validAwardSave = false;
    } else {
      return this.validAwardSave = true;
    }
  }

  // Save Award Information
  saveAwardInformationEntry(value: string) {
    this.isDirtyCheck = value;
    this.saveFlag = this.validateSave();
    if (this.saveFlag) {
      this.setAwardInformationHeader();
    } else {
      this.dialogRef = this.dialogService.open({
        title: 'Information',
        content: 'Please fill all mandatory fields',
        actions: [
          { text: 'Ok', primary: true }
        ],
        width: 400,
      });
    }
  }

  // Set Award Information Header
  setAwardInformationHeader() {
    Common.loader('show');
    this.awardInfoHeader.id = this.agreementId ? this.agreementId : this.defaultGuid;
    this.awardInfoHeader.donorId = this.awardEntryForm.controls.donorAgency.value ? this.awardEntryForm.controls.donorAgency.value : 0;
    this.awardInfoHeader.donorAwardNumber = this.awardEntryForm.controls.donorAwardNumber.value ?
      this.awardEntryForm.controls.donorAwardNumber.value : null;
    this.awardInfoHeader.egpafAwardNumber = this.awardEntryForm.controls.egpafAwardNumber.value ?
      this.awardEntryForm.controls.egpafAwardNumber.value : null;
    this.awardInfoHeader.title = this.awardEntryForm.controls.awardTitle.value ?
      this.awardEntryForm.controls.awardTitle.value : null;
    this.awardInfoHeader.nickName = this.awardEntryForm.controls.nickName.value ?
      this.awardEntryForm.controls.nickName.value : null;
    this.awardInfoHeader.agreementStatusId = this.awardEntryForm.controls.awardStatus.value ?
      this.awardEntryForm.controls.awardStatus.value : 0;
    this.awardInfoHeader.projectStartDate = this.awardEntryForm.controls.projectStartDate.value ?
      CommonUtil.localToUTC(this.awardEntryForm.controls.projectStartDate.value) : null;
    this.awardInfoHeader.projectClosingDate = this.awardEntryForm.controls.projectCloseDate.value ?
      CommonUtil.localToUTC(this.awardEntryForm.controls.projectCloseDate.value) : null;
    this.awardInfoHeader.hasSubOrganization = this.awardEntryForm.controls.subToAnotherOrganization.value === 'Yes' ? true : false;
    this.awardInfoHeader.primeFunder = this.awardEntryForm.controls.primeFunder.value ?
      this.awardEntryForm.controls.primeFunder.value : null;
    this.awardInfoHeader.isMultiYear = this.awardEntryForm.controls.multiYearProject.value === 'Yes' ? true : false;
    if (this.awardEntryForm.controls.multiYearProject.value === 'No') {
      localStorage.setItem('awardAgreementYear', null);
    } else {
      this.awardInfoHeader.agreementYear = this.awardEntryForm.controls.agreementYear.value ?
      this.awardEntryForm.controls.agreementYear.value : 0;
      localStorage.setItem('awardAgreementYear', this.awardEntryForm.controls.agreementYear.value);
    }
    this.awardInfoHeader.acOfficerId = this.awardEntryForm.controls.acOfficer.value ?
      this.awardEntryForm.controls.acOfficer.value : null;
    this.awardInfoHeader.facsOfficerId = this.awardEntryForm.controls.facsOfficer.value ?
      this.awardEntryForm.controls.facsOfficer.value : null;
    this.awardInfoHeader.researchPOCId = this.awardEntryForm.controls.researchPOC.value ?
      this.awardEntryForm.controls.researchPOC.value : null;
    this.awardInfoHeader.donorPOCId = this.awardEntryForm.controls.donorPOC.value ?
      this.awardEntryForm.controls.donorPOC.value : null;

    let hasNRDApprove = null;
    if (this.awardEntryForm.controls.approvedAsNonResearch.value === 'Yes') {
      hasNRDApprove = true;
    }
    else if (this.awardEntryForm.controls.approvedAsNonResearch.value === 'No') {
      hasNRDApprove = false;
    }

    this.awardInfoHeader.hasNRDApproval = hasNRDApprove;

    let hasIRBApprove = null;
    if (this.awardEntryForm.controls.institutionalReviewBoard.value === 'Yes') {
      hasIRBApprove = true;
    }
    else if (this.awardEntryForm.controls.institutionalReviewBoard.value === 'No') {
      hasIRBApprove = false;
    }

    this.awardInfoHeader.hasIRB = hasIRBApprove;

    let isRndReq = null;
    if (this.awardEntryForm.controls.researchStudiesConducted.value === 'Yes') {
      isRndReq = true;
    }
    else if (this.awardEntryForm.controls.researchStudiesConducted.value === 'No') {
      isRndReq = false;
    }

    this.awardInfoHeader.isResearchRequired = isRndReq;
    this.awardInfoHeader.projectSponsorId = this.awardEntryForm.controls.projectSponsor.value ?
      this.awardEntryForm.controls.projectSponsor.value : null;
    this.awardInfoHeader.projectManagerId = this.awardEntryForm.controls.egpafProjectManager.value ?
      this.awardEntryForm.controls.egpafProjectManager.value : null;
    this.awardInfoHeader.egpafAgreementManagerId = this.awardEntryForm.controls.egpafAwardManager.value ?
      this.awardEntryForm.controls.egpafAwardManager.value : null;
    this.awardInfoHeader.countryProgramOfficerId = this.awardEntryForm.controls.countryProgramOfficer.value ?
      this.awardEntryForm.controls.countryProgramOfficer.value : null;
    this.awardInfoHeader.summary = this.awardEntryForm.controls.summaryText.value ?
      this.awardEntryForm.controls.summaryText.value : null;
    this.saveAawardInformation();
  }

  // Save API call for Award Information Header
  saveAawardInformation() {
    this.awardInfoService.postAwardInformation(JSON.stringify(this.awardInfoHeader)).subscribe((response: any) => {
      if (response) {
        this.agreementId = response;
      }
      this.saveAwardDetails();
    });
  }

  // Save API call for Award Details
  saveAwardDetails() {
    if (this.agreementId) {
      this.saveAgreementCountry();
    }
    Common.loader('hide');
  }

  public show() {
    this.notificationService.show({
      content: 'This has been saved.',
      position: { horizontal: 'center', vertical: 'bottom' },
      animation: { type: 'fade', duration: 800 },
      type: { style: 'success', icon: true },
      hideAfter: 5000,
    });
    this.routeAfterSave();
  }

  // To save the agreement Country
  public saveAgreementCountry() {
    if (this.agreementCountryList.length > 0) {
      this.agreementCountryList.forEach((element: any) => {
        if (this.agreementCountry.length > 0) {
          this.agreementCountry.forEach((getList: any) => {
            if (element.countryOfficeId === getList.countryOfficeId) {
              element.id = getList.id;
            }
          });
        }
        element.agreementId = this.agreementId;
      });
      this.awardInfoService.postSaveAgreementCountry(JSON.stringify(this.agreementCountryList)).subscribe((response: any) => {
        if (response) {
          this.allCountryList = [];
          this.awardInfoService.getAllCountry(this.agreementId).subscribe(async (res) => {
            this.allCountryList = res;
            if (this.allCountryList.length > 0) {
              await this.saveAgreementRegion();
              await this.saveCountryOfImplementation();
              this.saveAgreementActivity();
              this.saveAgreementDonorContact();
              this.saveAgreementTechnicalArea();
              this.deleteCountryImplementation();
              this.deleteAgreementCountry();
              this.deleteAgreementRegion();
              this.deleteAgreementActivity();
              this.deleteAgreementDonorContact();
              this.deleteTechnicalArea();
              if (this.isDocumentEmitTrue === false) {
                this.saveDocuments();
              }
              this.show();
            }
          });
        }
      });
    } else {
      this.saveAgreementRegion();
      this.saveCountryOfImplementation();
      this.saveAgreementActivity();
      this.saveAgreementDonorContact();
      this.saveAgreementTechnicalArea();
      this.deleteCountryImplementation();
      this.deleteAgreementCountry();
      this.deleteAgreementRegion();
      this.deleteAgreementActivity();
      this.deleteAgreementDonorContact();
      this.deleteTechnicalArea();
      if (this.isDocumentEmitTrue === false) {
        this.saveDocuments();
      }
      this.show();
    }
  }

  // To save the agreement Region
  public saveAgreementRegion() {
    if (this.agreementRegionList.length > 0) {
      this.agreementRegionList.forEach((element: any) => {
        if (this.allCountryList.length > 0) {
          this.allCountryList.forEach((getList: any) => {
            if (element.countryName === getList.countryName) {
              element.countryId = getList.countryOfficeId;
            }
            if (element.countryOfficeId === getList.countryOfficeId) {
              element.id = getList.id;
            }
          });
        }
        element.agreementId = this.agreementId;
      });
      this.awardInfoService.postSaveAgreementRegion(JSON.stringify(this.agreementRegionList)).subscribe((response: any) => { });
    }
  }

  // To save the agreement Activity
  public saveAgreementActivity() {
    if (this.postAgreementActivities.length > 0) {
      this.postAgreementActivities.forEach((element: any) => {
        if (this.agreementActivities.length > 0) {
          this.agreementActivities.forEach((el: any) => {
            if (element.activityName === el.activityName) {
              element.id = el.id;
            }
          });
        }
        element.agreementId = this.agreementId;
      });
      this.awardInfoService.postAgreementActivity(JSON.stringify(this.postAgreementActivities)).subscribe((response: any) => { });
    }
  }

  // To save the agreement DonorContact
  public saveAgreementDonorContact() {
    if (this.agreementDonorContactList.length > 0) {
      this.agreementDonorContactList.forEach((element: any) => {
        const donorContact: IDonorContact = {};
        if (element.donorContactId !== this.defaultGuid) {
          element.agreementId = this.agreementId;
          donorContact.id = element.donorContactId;
          donorContact.contactId = element.contactId;
          donorContact.donorId = this.donorId;
          donorContact.name = element.name;
          donorContact.title = element.title;
          donorContact.email = element.email;
          donorContact.note = element.note;
          element.donorContact = {};
          element.donorContact = donorContact;
        }
        element.agreementId = this.agreementId;
      });
      this.awardInfoService.postSaveAgreementDonorContact(JSON.stringify(this.agreementDonorContactList)).subscribe((response: any) => {
      });
    }
  }

  // To save the agreement TechnicalArea
  public saveAgreementTechnicalArea() {
    if (this.saveTechnicalArea.length > 0) {
      this.saveTechnicalArea.forEach((element: any) => {
        element.agreementId = this.agreementId;
      });
      this.awardInfoService.postAgreementTechnicalArea(JSON.stringify(this.saveTechnicalArea)).subscribe((response: any) => {
      });
    }
  }

  // To save the Country of Implementation
  public saveCountryOfImplementation() {
    if (this.countryOfImplementationList.length > 0) {
      this.countryOfImplementationList.forEach((element: any) => {
        if (this.allCountryList.length > 0) {
          this.allCountryList.forEach((getList: any) => {
            if (element.name === getList.countryName) {
              element.countryOfficeId = getList.countryOfficeId;
            }
            if (element.id === getList.id) {
              element.id = getList.id;
            }
          });
        }
        element.agreementId = this.agreementId;
      });
      this.awardInfoService.postCountryImplementation(JSON.stringify(this.countryOfImplementationList)).subscribe();
    }
  }

  // To delete the Country Implementation
  public deleteCountryImplementation() {
    if (this.deleteCountryImplementationIds.length > 0) {
      this.awardInfoService.deleteCountryImplementation(JSON.stringify(this.deleteCountryImplementationIds)).subscribe((response: any) => {
      });
    }
  }

  // To delete the agreement country.
  public deleteAgreementCountry() {
    if (this.deleteCountryIds.length > 0) {
      this.awardInfoService.deleteAgreementCountry(JSON.stringify(this.deleteCountryIds)).subscribe((response: any) => {
      });
    }
  }

  // To delete the agreement region.
  public deleteAgreementRegion() {
    if (this.deleteRegionIds.length > 0) {
      this.awardInfoService.deleteAgreementRegion(JSON.stringify(this.deleteRegionIds)).subscribe((response: any) => {
      });
    }
  }

  // To delete the agreement activity.
  public deleteAgreementActivity() {
    if (this.deleteActivityIds.length > 0) {
      this.awardInfoService.deleteAgreementActivity(JSON.stringify(this.deleteActivityIds)).subscribe((response: any) => {
      });
    }
  }

  // To delete the agreement donor contact.
  public deleteAgreementDonorContact() {
    if (this.deleteDonorContactIds.length > 0) {
      this.awardInfoService.deleteAgreementDonorContact(JSON.stringify(this.deleteDonorContactIds)).subscribe((response: any) => {
      });
    }
  }

  // To delete the agreement technical area.
  public deleteTechnicalArea() {
    if (this.deleteTechnicalAreaIds.length > 0) {
      this.awardInfoService.deleteTechnicalArea(JSON.stringify(this.deleteTechnicalAreaIds)).subscribe((response: any) => {
      });
    }
  }

  // To save documents
  public saveDocuments() {
    if (this.documentComponent) {
      if (this.documentComponent.newUploadFileList.length > 0) {
        this.documentComponent.newUploadFileList.forEach((element: any) => {
          element.agreementId = this.agreementId;
        });
        this.commonService.saveDocument(JSON.stringify(this.documentComponent.newUploadFileList)).subscribe((response: any) => {
          if (response) {
            this.documentComponent.isEnableDocumentDialug = false;
          }
        });
      }
    }
  }

  // To cancel award information entry
  cancelAwardInformationEntry() {
    this.dialogRef = this.dialogService.open({
      title: 'PleaseConfirm',
      content: 'Are you sure you want to cancel this?',
      actions: [
        { text: 'Yes', primary: true },
        { text: 'No' }],
      width: 400,
    });
    this.dialogRef.result.subscribe((rs: any) => {
      if (rs.text && rs.text === 'Yes') {
        this.router.navigateByUrl('/DummyComponent', { skipLocationChange: true }).then(() =>
          this.router.navigate(['/dashboard']));
      }
    });
  }

  routeAfterSave() {
    if (this.isDirtyCheck !== 'dirtyCheck') {
      if (this.selectedPage || this.targetPage) {
        const element: HTMLElement = document.getElementById('submitBtn') as HTMLElement;
        element.click();
        this.awardEntryForm.reset();
      } else {
        this.router.navigateByUrl('/DummyComponent', { skipLocationChange: true }).then(
          () => this.router.navigate(['/award-information-entry'],
            { queryParams: { id: this.agreementId } }));
      }
    }
  }

  routeAfterDocumentSave() {
    this.dialogRef = this.dialogService.open({
      title: 'Information',
      content: 'Document Saved Successfully',
      actions: [
        { text: 'Ok', primary: true }
      ],
      width: 400,
    });

    this.dialogRef.result.subscribe((rs: any) => {
      if (rs.text && rs.text === 'Ok') {
        this.documentComponent.getDocumentDetails();
        this.router.navigateByUrl('/DummyComponent', { skipLocationChange: true }).then(
          () => this.router.navigate(['/award-information-entry'],
            { queryParams: { id: this.agreementId } }));
      }
    });
  }

  // On activity remove event.
  public onRemoveActivity(event: any) {
    if (event && this.agreementActivities.length > 0) {
      const removeActivity = this.agreementActivities.find(e => e.activityName === event.dataItem);
      this.deleteActivityIds.push(removeActivity?.id);
    }
  }

  public onRemoveDonorContact(event: any) {
    if (this.agreementDonorContact.length > 0 && event.dataItem) {
      const removeDonorContact = this.agreementDonorContact.find(e => e.donorContactId === event.dataItem.donorContactId);
      this.deleteDonorContactIds.push(removeDonorContact?.id);
      if (this.agreementDonorContactList.length > 0) {
        this.agreementDonorContactList.forEach((element, index) => {
          if (element.contactId === event.dataItem.ContactId) {
            this.agreementDonorContactList.splice(index, 1);
          }
        });
      }
    }
  }

  public onRemoveAgreementCountry(event: any) {
    if (this.agreementCountry.length > 0 && event.dataItem) {
      const removeAgreementCountry = this.agreementCountry.find(e => e.countryOfficeId === event.dataItem.countryOfficeId);
      if (removeAgreementCountry) {
        var index = this.agreementCountry.findIndex(s => s.countryOfficeId === event.dataItem.countryOfficeId);
        this.agreementCountry.splice(index, 1);
        this.deleteCountryIds.push(removeAgreementCountry?.id);
      }
    }
    if (this.agreementCountryList.length > 0 && event.dataItem) {
      const removeAgreementCountry1 = this.agreementCountryList.find(e => e.countryRegionName === event.dataItem.name);
      if (removeAgreementCountry1) {
        var index = this.agreementCountryList.findIndex(s => s.countryRegionName === event.dataItem.name);
        this.agreementCountryList.splice(index, 1);
      }
    }
    if (this.selectedNewCountryItems.length > 0 && event.dataItem) {
      const removeAgreementCountry2 = this.selectedNewCountryItems.find(e => e === event.dataItem.countryOfficeId);
      if (removeAgreementCountry2) {
        var index = this.selectedNewCountryItems.findIndex(s => s === event.dataItem.countryOfficeId);
        this.selectedNewCountryItems.splice(index, 1);
      }
    }
  }

  public onRemoveAgreementRegion(event: any) {
    if (this.agreementRegion.length > 0 && event.dataItem) {
      const removeAgreementRegion = this.agreementRegion.find(e => e.regionId === event.dataItem.regionId);
      if (removeAgreementRegion) {
        var index = this.agreementRegion.findIndex(s => s.regionId === event.dataItem.regionId);
        this.agreementRegion.splice(index, 1);
        this.deleteRegionIds.push(removeAgreementRegion?.id);
      }
    }
    if (this.agreementRegionList.length > 0 && event.dataItem) {
      const removeAgreementRegion = this.agreementRegionList.find(e => e.other === event.dataItem.countryRegionName);
      if (removeAgreementRegion) {
        var index = this.agreementRegionList.findIndex(s => s.other === event.dataItem.countryRegionName);
        this.agreementRegionList.splice(index, 1);
      }
    }
    if (this.selectedNewRegionItems.length > 0 && event.dataItem) {
      const removeAgreementRegion = this.selectedNewRegionItems.find(e => e === event.dataItem.regionId);
      if (removeAgreementRegion) {
        var index = this.selectedNewRegionItems.findIndex(s => s === event.dataItem.regionId);
        this.selectedNewRegionItems.splice(index, 1);
      }
    }
  }

  onRemovetechnicalArea(event: any) {
    if (this.agreementTechnicalArea.length > 0 && event.dataItem) {
      const removeTechnicalAreaList = this.agreementTechnicalArea.find(e => e.technicalAreaId === event.dataItem.technicalAreaId);
      this.deleteTechnicalAreaIds.push(removeTechnicalAreaList?.id);
    }
  }

  subToAnotherOrganizationYes() {
    this.enablePrimeFunder = true;
  }

  subToAnotherOrganizationNo() {
    this.enablePrimeFunder = false;
  }

  multiYearProjectYes() {
    this.hasMultipleYear = true;
  }

  multiYearProjectNo() {
    this.hasMultipleYear = false;
    if (this.agreementYear) {
      this.awardInfoService.getIsAwardYearUsed(this.agreementId, 1, this.getAwardYear).subscribe((resp: any) => {
        if (resp === true) {
          this.dialogRef = this.dialogService.open({
            title: 'Information',
            content: 'Award year already mapped with other records',
            actions: [
              { text: 'Ok', primary: true }
            ],
            width: 400,
          });
          this.dialogRef.result.subscribe((rs: any) => {
            if (rs instanceof DialogCloseResult) {
              this.awardEntryForm.patchValue({ agreementYear: this.getAwardYear });
            }
            if (rs.text && rs.text === 'Ok') {
              this.awardEntryForm.patchValue({ agreementYear: this.getAwardYear });
            }
          });
          this.hasMultipleYear = true;
          this.awardEntryForm.patchValue({ multiYearProject: 'Yes' });
        } else if (resp === true) {
          this.hasMultipleYear = false;
          this.awardEntryForm.patchValue({ multiYearProject: 'No' });
        }
      });
    }
  }

  validateAwardNumber(event: any) {
    if (event.target.value) {
      this.awardNumberValidate = false;
    }
  }

  validateAwardTitle(event: any) {
    if (event.target.value) {
      this.awardTitleValidate = false;
    }
  }

  validateAwardNickName(event: any) {
    if (event.target.value) {
      this.awardNickNameValidate = false;
    }
  }

  // Country of Implementation Grid Data Start
  public addHandler({ sender }) {
    this.closeEditor(sender);
    this.awardEntryForm.patchValue({ cOICountry: '' });
    this.awardEntryForm.patchValue({ cOIManager: '' });
    this.awardEntryForm.patchValue({ activityName: '' });
    sender.addRow(this.awardEntryForm);
  }

  public editHandler({ sender, rowIndex, dataItem }) {
    this.closeEditor(sender);
    this.awardEntryForm.patchValue({ cOICountry: dataItem.countryOfficeId });
    this.awardEntryForm.patchValue({ cOIManager: dataItem.userId });
    this.awardEntryForm.patchValue({ activityName: dataItem.activityName });
    this.editedRowIndex = rowIndex;
    sender.editRow(rowIndex, this.awardEntryForm);
  }

  public cancelHandler({ sender, rowIndex }) {
    this.closeEditor(sender, rowIndex);
  }

  public saveHandler({ sender, rowIndex, formGroup, isNew, dataItem }): void {
    const tempList: ICOISave = {};
    const selectedCountry = this.countryList.find((el) => el.countryOfficeId === formGroup.controls.cOICountry.value);
    const selectedManager = this.allUsersList.find((el) => el.id === formGroup.controls.cOIManager.value);
    const selectedActivity = formGroup.controls.activityName.value;
    if (selectedCountry) {
      tempList.countryOfficeId = selectedCountry.countryOfficeId;
      tempList.name = selectedCountry.name;
      tempList.countryRegionName = selectedCountry.name;
    }
    if (selectedManager) {
      tempList.managerId = selectedManager.id;
      tempList.userId = selectedManager.id;
      tempList.managerName = selectedManager.displayName;
      tempList.displayName = selectedManager.displayName;
    }
    if (selectedActivity) {
      tempList.activityName = selectedActivity;
    }
    if (isNew) {
      tempList.rowId = this.counter++;
      this.countryOfImplementationList.push(tempList);
      this.countryImplementationGrid = process(this.countryOfImplementationList, this.reqstate);
    } else {
      if (dataItem.id) {
        Object.assign(
          this.countryOfImplementationList.find(({ id }) => id === dataItem.id),
          tempList
        );
      } else {
        Object.assign(
          this.countryOfImplementationList.find(({ rowId }) => rowId === rowIndex),
          tempList
        );
      }
      this.countryImplementationGrid = process(this.countryOfImplementationList, this.reqstate);
    }
    sender.closeRow(rowIndex);
  }

  public removeHandler({ dataItem }): void {
    if (dataItem.id) {
      const index = this.countryOfImplementationList.findIndex(({ id }) => id === dataItem.id);
      this.deleteCountryImplementationIds.push(dataItem.id);
      this.countryOfImplementationList.splice(index, 1);
      this.countryImplementationGrid = process(this.countryOfImplementationList, this.reqstate);
    } else {
      const index = this.countryOfImplementationList.findIndex(({ countryOfficeId }) => countryOfficeId === dataItem.countryOfficeId);
      this.countryOfImplementationList.splice(index, 1);
      this.countryImplementationGrid = process(this.countryOfImplementationList, this.reqstate);
    }
  }

  private closeEditor(grid, rowIndex = this.editedRowIndex) {
    grid.closeRow(rowIndex);
    this.editedRowIndex = undefined;
    this.formGroup = undefined;
  }
  // Country of Implementation Grid Data End

  // document expand validation
  documentExpand(event: any) {
    this.validateDocumentExpandFlag = this.validateSave();
    if (!this.validateDocumentExpandFlag) {
      this.dialogRef = this.dialogService.open({
        title: 'Information',
        content: 'Please fill all mandatory fields',
        actions: [
          { text: 'Ok', primary: true }
        ],
        width: 400,
      });
      event.preventDefault();
    }
  }

  public onTabSelect(e: any) {
    if (this.agreementId) {
      if (this.targetPage) {
        this.selectedPage = this.targetPage;
        this.targetPage = e.index;
      } else {
        this.targetPage = e.index;
      }
      const Allform = document.querySelectorAll('.ng-dirty');
      if (Allform.length > 0) {
        e.prevented = true;
        this.dialogRef = this.dialogService.open({
          title: 'Please Confirm',
          content: 'You have unsaved changes! If you leave this tab, your changes will be lost. Would you like to save your changes?',
          actions: [
            { text: "Don't save" },
            { text: 'Save', primary: true }],
          width: 550,
        });
        this.dialogRef.result.subscribe((rs: any) => {
          if (rs.text && rs.text === "Don't save") {
            this.ngOnInit();
          } else if (rs.text === 'Save' && this.selectedPage === 0) {
            this.setAwardInformationHeader();
          } else if (rs.text === 'Save' && this.selectedPage === 1) {
            if (this.deliverableComponent.deliverableEntryForm.controls.deliverableType.value) {
              $('.deliverableSave').click();
            } else {
              this.deliverableComponent.mandatoryError();
              this.targetPage = this.selectedPage;
            }
          } else if (rs.text === 'Save' && this.selectedPage === 2) {
            if (this.priorApprovalsComponent.priorApprovalsEntryForm.controls.requiringApproval.value) {
              $('.priorApprovalSave').click();
            } else {
              this.priorApprovalsComponent.mandatoryError();
              this.targetPage = this.selectedPage;
            }
          } else if (rs.text === 'Save' && this.selectedPage === 3) {
            if (this.notesComponent.notesEntryForm.controls.title.value) {
              $('.notesSave').click();
            } else {
              this.notesComponent.mandatoryError();
              this.targetPage = this.selectedPage;
            }
          }
          this.tabstrip.selectTab(this.targetPage);
        });
      } else {
        if (this.targetPage === 0) {
          this.router.navigateByUrl('/DummyComponent', { skipLocationChange: true }).then(
            () => this.router.navigate(['/award-information-entry'],
              { queryParams: { id: this.agreementId } }));
        }
      }
    } else {
      e.prevented = true;
      this.dialogRef = this.dialogService.open({
        title: 'Information',
        content: 'Please create award before proceed',
        actions: [
          { text: 'Ok', primary: true }
        ],
        width: 400,
      });
    }
  }

  autoSave() {
    this.intervaltime = setInterval(() => {
      if (this.documentComponent === undefined || this.documentComponent.isEnableDocumentDialug === false) {
        if (this.awardEntryForm.touched) {
          const element: HTMLElement = document.getElementById('submitBtn') as HTMLElement;
          element.click();
          this.saveFlag = this.validateSave();
          if (this.saveFlag) {
            this.setAwardInformationHeader();
          } else {
            this.dialogRef = this.dialogService.open({
              title: 'Information',
              content: 'Please fill all mandatory fields',
              actions: [
                { text: 'Ok', primary: true }
              ],
              width: 400,
            });
          }
        }
      }
    }, +environment.autoSave);
  }

  // Donor POC grid column filter
  public categoryFilters(filter: CompositeFilterDescriptor): FilterDescriptor[] {
    this.categoryFilter.splice(
      0, this.categoryFilter.length,
      ...flatten(filter).map(({ value }) => value)
    );
    return this.categoryFilter;
  }

  public nameValueChange(values: any[], filterService: FilterService): void {
    filterService.filter({
      filters: values.map(value => ({
        field: 'name',
        operator: 'eq',
        value
      })),
      logic: 'or'
    });
  }

  public titleValueChange(values: any[], filterService: FilterService): void {
    filterService.filter({
      filters: values.map(value => ({
        field: 'title',
        operator: 'eq',
        value
      })),
      logic: 'or'
    });
  }

  public emailValueChange(values: any[], filterService: FilterService): void {
    filterService.filter({
      filters: values.map(value => ({
        field: 'email',
        operator: 'eq',
        value
      })),
      logic: 'or'
    });
  }

  // Country implementation grid column filter
  public countryValueChange(values: any[], filterService: FilterService): void {
    filterService.filter({
      filters: values.map(value => ({
        field: 'name',
        operator: 'eq',
        value
      })),
      logic: 'or'
    });
  }

  public managerValueChange(values: any[], filterService: FilterService): void {
    filterService.filter({
      filters: values.map(value => ({
        field: 'displayName',
        operator: 'eq',
        value
      })),
      logic: 'or'
    });
  }

  public activityValueChange(values: any[], filterService: FilterService): void {
    filterService.filter({
      filters: values.map(value => ({
        field: 'activityName',
        operator: 'eq',
        value
      })),
      logic: 'or'
    });
  }

  ngOnDestroy() {
    if (this.intervaltime) {
      clearInterval(this.intervaltime);
    }
  }
}
